<lh-workbench>
  <ng-template lh-workbench-template="main">
    <router-outlet/>
  </ng-template>
</lh-workbench>
